module.exports = __webpack_public_path__ + "img/noData.c34ba899.svg";